class Customer.ResponseTemplateAutomaticSettingsView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/response_template/automatic_settings"]

  events:
    'change #only-for-chatbot-assignation': 'onChangeOnlyForChatbotAssignation'

  modal:
    title: 'Automatic settings',
    buttons: [
      {
        title: 'Save settings',
        event: 'save'
      },
      {
        title: 'Cancel',
        event: 'exit'
      },
    ]

  initialize: (@options = {}) ->
    @model = @options.model
    @editor = @options.editor
    @collection = @model.collection
    @render()
    @modalTab = @options.modalTab

  render: ->
    @$el.html(@template({self: @}))
    @automaticButton = @$el.find('#automatic-button')
    @logicButton = @$el.find('#logic-button')
    @automaticResponse = @$el.find('#automatic-response')
    @automaticPriority = @$el.find('#automatic-priority')
    @ticketStatusAfterResponse = @$el.find('#conversation_status_after_response')
    @onlyForChatbotAssignation = @$el.find('#only-for-chatbot-assignation')
    @chatbotCode = @$el.find('#chatbot-code')
    if @onlyForChatbotAssignation.prop('checked')
      # nothing to do
    else
      @chatbotCode.css({visibility: 'hidden'})
    @modal.title = I18n.t('monitoring.user_settings.predefined_templates.automatic_settings.title')
    @modal.buttons[0].title = I18n.t('monitoring.user_settings.predefined_templates.save')
    @modal.buttons[1].title = I18n.t('monitoring.user_settings.predefined_templates.cancel')    
    @automaticButton.bootstrapToggle({width: 80, height: 20});
    @logicButton.bootstrapToggle({width: 80, height: 20});
    @automaticResponse.bootstrapToggle({width: 80, height: 20});
    @onlyForChatbotAssignation.bootstrapToggle({width: 80, height: 20})
    @automaticPriority.simpleSlider(
      range: [1,10]
      snap: true
      step: 1
    ).bind("slider:changed", @changedPriorityValue);
    @

  togglePublicToPrivateVisibility: (show) =>
    @$el.find('#public_to_private').toggleClass 'hidden', not show

  changedPriorityValue: (e, data) =>
    @$el.find('#priority-number').text(data.value)

  resizeAP: =>
    @automaticPriority.trigger('resize')
    @automaticPriority.val(@model.get('priority')).change()

  exit: =>
    @modalTab.removeModal();
    @remove();

  save: =>
    if @onlyForChatbotAssignation.prop('checked')
      if @chatbotCode.val() == ''
        @chatbotCode.addClass('error')
        return
      else
        @chatbotCode.removeClass('error')
    if @editor.validate()
      @editor.save()
    else
      @editor.activate()

  saveToServer: =>
    @model.save(@_serialize(), {success: @updateModel})

  publicToPrivate: =>
    @$el.find('#public_to_private:not(.hidden) > select').val() == 'true'

  _serialize: ->
    results = {}
    results['automatic'] = @automaticButton.prop('checked')
    results['tags_logic'] = if @logicButton.prop('checked') then 'OR' else 'AND'
    results['use_work_calendar'] = @automaticResponse.prop('checked')
    results['priority'] = parseInt(@automaticPriority.val())
    results['private_reply_for_public_contents'] = @publicToPrivate()
    results['conversation_status_after_response'] = @ticketStatusAfterResponse.val()
    if @onlyForChatbotAssignation.prop('checked')
      results['assign_to_operator_id'] = 0
      if @chatbotCode.val()
        results['chatbot_code'] = @chatbotCode.val().trim()
      else
        swal('Please select a valid Bot Id')
        throw new Error('chatbotCode does not have a value')
    else
      results['assign_to_operator_id'] = -1
    results

  updateModel: (model, data) =>
    model.set(data)
    @exit()

  onChangeOnlyForChatbotAssignation: ->
    if @onlyForChatbotAssignation.prop('checked')
      @chatbotCode.css({visibility: 'visible'})
    else
      @chatbotCode.css({visibility: 'hidden'})
